<template>
  <div class="typing" aria-label="AI is typing">
    <span v-for="n in 3" :key="n" class="dot" :style="{ animationDelay: (n*0.2)+'s' }" />
  </div>
</template>

<style scoped>
.typing {
  display: flex;
  gap: 4px;
  padding-left: 2.5rem; /* align under assistant bubbles */
  align-self: flex-end;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #4f46e5;
  opacity: 0.8;
  animation: bounce 1s infinite ease-in-out;
}

@keyframes bounce {
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1); }
}
</style>